import { Fragment, useEffect, useState } from "react";
import { saveAs } from "file-saver";
import { useHistory, useLocation } from "react-router-dom";
//--------------------------------------------------------------------------------------------
import Resize from "src/components/common/resize";
import magnifierImg from "src/img/magnifier.png";
import UserInfo from "src/components/common/userInfo";
import Footer from "src/components/common/frame/footer";
import { useMyStore } from "src/components/main/mainStore";
import { 
    onlyUnique, getTimeStamp, 
    boolAndReducer, weeknum, 
    myAxios, MyFormData, 
    mimeTypeMap, scroll,
    isMobilePhone,
    objDescSort,
    appTitle, 
} from "src/components/common/functions";
import AddForm from "./addForm";
import FilterForm from "./filterForm";
import Detail from "./detail";
import Export from "./export";
//--------------------------------------------------------------------------------------------
export default function Forms({tabTitle}){
    const setShowLoader = useMyStore(state => state.setShowLoader);
    const user = useMyStore(state => state.user);
    const [updateDateTime, setUpdateDateTime] = useState(getTimeStamp());
    const [formPicData, formSetPicData] = useState([]);
    const [formSketches, formSetSketches] = useState([]);
    const statusColorCode = status => {
        switch(status){
            case "Submitted":
                return "black";
            case "Re-Submitted":
                return "purple";
            case "Approved":
                return "green";
            case "Rejected":
                return "gray";
            default:
        }
    }
    //--------------------------------------------------------------------------------------------
    const defaultFilter = {
        void: "0", 
        submitter: "",
        requestDate: "",
        totalMin: "",
        totalMax: "",
        approver: "",
        status: "",
        department: ""
    };
    const [curFilter, setFilter] = useState(defaultFilter);
    const [showFilter, setShowFilterForm] = useState(false);
    const [curWeeks, setWeeks] = useState([]);
    const [curWeekStart, setWeekStart] = useState("");
    const [curWeekEnd, setWeekEnd] = useState("");
    const [userList, setUserList] = useState([]);
    const [showLoading, setShowLoading] = useState(false);
    const [usersList, setUsersList] = useState([]);
    const [usersListMap, setUsersListMap] = useState();
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [filterWords, setFilterWords] = useState("");
    //--------------------------------------------------------------------------------------------
    const history = useHistory();
    const location = useLocation();
    //--------------------------------------------------------------------------------------------
    const title = location.pathname.split("/")[1];
    const id = location.pathname.split("/")[2];
    const idid = location.pathname.split("/")[3];
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const filterUserList = userList?.map(u => ({...u, 
        dateUpdated: (!u.dateUpdated?"":u.dateUpdated),
        status: (!u.dateSaved && !u.dateSubmitted)?
        "Created":
        u.dateCompleted?"Handled":
        (u.dateSubmitted?
        "Submitted":"Saved")
    })).filter(u => 
        (user.forms === "approver"?true:[u.submitterEmail, u.approverEmail].includes(user.email))
        && (user.projects === "no"?user.email === u.submitterEmail:true)
        && (curWeekStart?(weeknum(u.dateCreated.substring(0, 10)) >= curWeekStart):true)
        && (curWeekEnd?(weeknum(u.dateCreated.substring(0, 10)) <= curWeekEnd):true)
        && (curFilter.void === "All"?true:(u.void === curFilter.void))
        && (curFilter.submitterEmail?u.submitterEmail === curFilter.submitterEmail:true)
        && (curFilter.department?u.department === curFilter.department:true)
        && (curFilter.requestDate?JSON.parse(u.data).map(u => u.date).includes(curFilter.requestDate):true)
        && (curFilter.totalMin?window.Number.parseFloat(u.totalHours) >= window.Number.parseFloat(curFilter.totalMin):true)
        && (curFilter.totalMax?window.Number.parseFloat(u.totalHours) <= window.Number.parseFloat(curFilter.totalMax):true)
        && (curFilter.approver?u.approverEmail === curFilter.approver:true)
        && (curFilter.status?u.status === curFilter.status:true)
        && (filterWords.toLowerCase().split(" ").map(f => JSON.stringify(
            Object.values(u)
        ).toLowerCase().indexOf(f) > -1).reduce(boolAndReducer, true))
    );
    const currentUserList = filterUserList.slice(indexOfFirstItem, indexOfLastItem);
    const pageNumbers = Array.from({length: Math.ceil(filterUserList.length / itemsPerPage)}, (_, i) => (i + 1));
    //--------------------------------------------------------------------------------------------
    useEffect(() => {
        let isMounted = true;
        const id = history.location.pathname.split("/")[2];
        setShowLoading(true);
        const getData = async() => {
            
            const resUser = await myAxios("common/readUserNames.php");
            if(!isMounted) return;
            const users = resUser.data.map(user => ({...user, value: user.email, label: user.userName}));
            setUsersList(users);
            setUsersListMap(Object.fromEntries(users.map(user => 
                [user.value, user.label]
            )));

            const res = await myAxios("forms/readForms.php");
            if(!isMounted) return;
            setUserList(res.data);
            const weeks = res.data.map(r => weeknum(r.dateCreated.substring(0, 10))).filter(onlyUnique).sort().reverse();
            setWeeks(weeks);
            setWeekStart(weeks[0]);
            setWeekEnd(weeks[0]);
            setShowLoading(false);
            if(!res.data.find(u => id === u.formHashKey)){
                switch(id){
                    case "Add":
                        return;
                    case undefined:
                        return
                    default:
                }
                history.replace(`/${title}`);
                return;
            }
            const po = res.data.find(u => id === u.formHashKey);
            if(po.void === "1"){setFilter(f => ({...f, void: "1"}));}
            setWeekStart(weeknum(po.dateCreated.substring(0, 10)));
            setWeekEnd(weeknum(po.dateCreated.substring(0, 10)));
            const hashkeys = res.data
            .filter(u => u.void === po.void)
            .filter(u => weeknum(u.dateCreated.substring(0, 10)) === weeknum(po.dateCreated.substring(0, 10)))
            .map(v => v.formHashKey);
            setCurrentPage(Math.ceil((hashkeys.indexOf(id) + 1) / itemsPerPage));
            scroll(id);
        }
        getData();
        return () => {isMounted = false}
    },[history, title, updateDateTime])
    useEffect(() => {
        document.title = tabTitle;
        return () => {
            document.title = appTitle;
        };
    }, [tabTitle]);
    //--------------------------------------------------------------------------------------------
    return(
        <div className = "cssTab">
            <div className = "cssHeader" style = {{background: user.userTheme}}>
                <span>
                    <Resize/>
                    {title}
                    <span data-toggle = "tooltip" title = {"Refreshed on " + updateDateTime} className = "btn btn-primary py-1 ml-4" onClick = {() => setUpdateDateTime(getTimeStamp())}>↻</span>
                </span>
                <span>
                    <input
                        className = "form-control w-auto"
                        type = "text"
                        value = {filterWords}
                        onChange = {e => {
                            setFilterWords(e.currentTarget.value.toLowerCase());
                            setCurrentPage(1);
                        }}
                    />
                    <img alt = "" src = {magnifierImg}/>
                </span>
                <span className = "d-flex align-items-center">
                    <label htmlFor = "start" className = "mb-0">Week Start:</label>
                    <select
                        id = "start"
                        className = "form-control w-atuo ml-2"
                        value = {curWeekStart}
                        onChange = {e => {
                            setWeekStart(e.currentTarget.value);
                            setCurrentPage(1);
                        }}
                    >
                        {curWeeks.map((c, ci) => <option key = {ci}>{c}</option>)}
                    </select>
                </span>
                <span className = "d-flex align-items-center">
                    <label htmlFor = "end" className = "mb-0">Week End:</label>
                    <select
                        id = "end"
                        className = "form-control w-auto ml-2"
                        value = {curWeekEnd}
                        onChange = {e => {
                            setWeekEnd(e.currentTarget.value);
                            setCurrentPage(1);
                        }}
                    >
                        {curWeeks.map((c, ci) => <option disabled = {c < curWeekStart} key = {ci}>{c}</option>)}
                    </select>
                </span>
                <span className = "pointer rounded p-1" style = {{
                    backgroundColor: Object.entries(curFilter).find(([key, value]) => defaultFilter[key] !== value)?
                    "rgb(0,123,255)"
                    :""
                }} onClick = {() => {setShowFilterForm(true)}}>
                    Filter
                </span>
                {showFilter?
                <FilterForm
                    usersList = {usersList}
                    setCurrentPage = {setCurrentPage}
                    curFilter = {curFilter}
                    setFilter = {setFilter}
                    closeIt = {() => setShowFilterForm(false)}
                    defaultFilter = {defaultFilter}
                />:<></>}
                <span className = "pointer" onClick = {() => {history.push(`/${title}/Add`);}}>Add</span>
                {filterUserList.length?
                <Export
                    filterUserList = {filterUserList}
                />
                :<></>}
            </div>
            <div className = "cssContent pb10">
                {showLoading?<div className = "cssLoading">Loading...</div>:
                !filterUserList.length?<div className = "cssLoading">Empty</div>:
                <div className = "table-responsive">
                    <table className = "table">
                        <thead className = "noTableTopBorder">
                            <tr>
                                <th></th>
                                {!isMobilePhone?<>
                                <th>Name</th>
                                <th>Department</th>
                                </>:<></>}
                                <th>Type</th>
                                {!isMobilePhone?<>
                                <th>Created On</th>
                                <th>Saved On</th>
                                <th>Submitted On</th>
                                <th>Approver</th>
                                <th>Completed On</th>
                                <th>Completed by</th>
                                </>:<></>}
                                <th>Status</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {id === "Add"?
                            <AddForm
                                setUserList = {setUserList}
                                keyword = "Add"
                                closeIt = {() => {
                                    // if(adminLink){
                                    //     history.push(`${adminLink}/${id}`);
                                    // }else{
                                        history.push(`/${title}`);
                                    // }
                                }}
                                sketches = {formSketches}
                                setSketches = {formSetSketches}
                                picData = {formPicData} 
                                setPicData = {formSetPicData}
                            />:<></>}
                            {currentUserList.sort((a, b) => objDescSort(a, b, "dateCreated")).map((form, key) => 
                            <Fragment key = {key}>
                            <tr id = {form.formHashKey}
                            style = {{
                                color:statusColorCode(form.status),
                                cursor:[
                                    ...usersList.filter(u => u.forms === "approver").map(u => u.email),
                                    form.approverEmail,
                                    form.submitterEmail
                                ].includes(user.email)?"pointer":""
                            }} onClick = {e => {
                                if(!e.target.id){
                                    if([
                                        ...usersList.filter(u => u.forms === "approver").map(u => u.email),
                                        form.approverEmail,
                                        form.submitterEmail
                                    ].includes(user.email) && id !== e.currentTarget.id){
                                        history.push(`/${title}/${e.currentTarget.id}`);
                                        scroll(e.currentTarget.id);
                                    }else{
                                        history.push(`/${title}`);
                                        scroll(null);
                                    }
                                }
                            }}>
                                <td className = {
                                    ![
                                        ...usersList.filter(u => u.forms === "approver").map(u => u.email),
                                        form.approverEmail,
                                        form.submitterEmail
                                    ].includes(user.email)?"":id === form.formHashKey?"showMinus":"showPlus"}></td>
                                {!isMobilePhone?<>
                                <td id = {form.submitterEmail}>
                                    <UserInfo 
                                        name = {form.submitter}
                                        email = {form.submitterEmail}
                                    />
                                </td>
                                <td>{form.department}</td>
                                </>:<></>}
                                <td>{form.formType}</td>
                                {!isMobilePhone?<>
                                <td>{form.dateCreated}</td>
                                <td>{!form.dateSaved?"":form.dateSaved}</td>
                                <td>{!form.dateSubmitted?"":form.dateSubmitted}</td>
                                <td>
                                    <UserInfo 
                                        name = {form.approver}
                                        email = {form.approverEmail}
                                    />
                                </td>
                                <td>{!form.dateCompleted?"":form.dateCompleted}</td>
                                <td>
                                    <UserInfo 
                                        name = {usersListMap?.[form.completerEmail]}
                                        email = {form.completerEmail}
                                    />
                                </td>
                                </>:<></>}
                                <td>{form.status}</td>
                                <td>
                                    {["Submitted", "Handled"].includes(form.status) && ([
                                        ...usersList.filter(u => u.forms === "approver").map(u => u.email),
                                        form.approverEmail,
                                        form.submitterEmail
                                    ].includes(user.email) || user.form === "all")?
                                    <span id = {form.id} className = "btn btn-success" onClick = {async() => {
                                        if(!form.id){
                                            window.alert("PDF Error.");
                                            return
                                        };
                                        setShowLoader(true);
                                        const formData = new MyFormData();
                                        formData.append("fileId[]", form.id);
                                        const res = await myAxios("common/getFile.php", formData, "blob");
                                        const file = new Blob([res.data], {type: mimeTypeMap.pdf});
                                        saveAs(file, `${form.formType} - ${form.dateCreated}.pdf`);
                                        setShowLoader(false);
                                    }}>
                                        Form
                                    </span>
                                    :<></>}
                                </td>
                            </tr>
                            <tr>
                                <td className = "noborder" colSpan = {100}>
                                    <Detail
                                        title = {title}
                                        setUserList = {setUserList}
                                        usersListMap = {usersListMap}
                                        id = {id}
                                        idid = {idid}
                                        form = {form}
                                        forms = {filterUserList}
                                        history = {history}
                                        usersList = {usersList}
                                        formSketches = {formSketches}
                                        formSetSketches = {formSetSketches}
                                        formPicData = {formPicData} 
                                        formSetPicData = {formSetPicData}
                                    />
                                </td>
                            </tr>
                            </Fragment>)}
                        </tbody>
                    </table>
                </div>}
                {!showLoading && filterUserList.length?
                <Footer
                    length = {filterUserList.length}
                    pageNumbers = {pageNumbers}
    
                    currentPage = {currentPage}
                    setCurrentPage = {setCurrentPage}
                    itemsPerPage = {itemsPerPage}
                    setItemsPerPage = {setItemsPerPage}
                />
                :null}
            </div>
        </div>
    )
}